import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { useEligibilityBinding } from 'growth-payments-core/eligibility/eligibilityBinding';
import { calculateKYCStatus, hasCompletedStripe } from 'growth-payments-core/eligibility/utils';
import GoToProcessorPickerButton from 'payments-enrollment-embed-lib/buttons/GoToProcessorPickerButton';
import { jsx as _jsx } from "react/jsx-runtime";
const GoToProcessorPickerButtonWrapper = _ref => {
  let passthroughProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const [eligibility] = useEligibilityBinding();
  const hasCompletedEnrollment = hasCompletedStripe(calculateKYCStatus(eligibility === null || eligibility === void 0 ? void 0 : eligibility.underwritingStatus));
  if (!eligibility || hasCompletedEnrollment) return null;
  return /*#__PURE__*/_jsx(GoToProcessorPickerButton, Object.assign({
    openInCommerceHome: true,
    external: true
  }, passthroughProps));
};
export default GoToProcessorPickerButtonWrapper;